module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/main-bg_dae4ffe06741cda893ec8948900faf99.jpg";